import axios from 'axios'
import toast from 'react-hot-toast'
import { decryptData, encryptData } from './Encrypt'
import i18next from 'i18next'
import { Spinner } from 'reactstrap'
import { ls } from 'Helpers/LocalStorageEncrypt'
// import { store } from 'redux/store'
// import { handleLogout } from 'Pages/Auth/store'

// const API_URL = 'http://192.168.1.5:8000/api'
// export const API_URL = 'http://localhost:8000/api'
export const API_URL = 'https://api.ebtkar-platform.com/api'

    const getToken = () => {
        const token = ls.getItem("token")
        return token
    }

    const getCountry = () => {
        const country = localStorage.getItem("country") ?? 'egypt'
        return country
    }

    const getCrudHeaders = () => {
        return {
            'Content-Type': "multipart/form-data",
            'user-type': 'user',
            'Country': getCountry()
        }
    }
    const getBaseHeaders = () => {
        return {
            'Content-Type': "application/json",
            'user-type': 'user',
            'Country': getCountry()
        }
    }

    const handleError = (code) => {
        if (code === 417) {
            // store.dispatch(handleLogout())
        }
    }

    export const CRUD_API = axios.create({
        baseURL: API_URL,
        headers: getCrudHeaders()
    })
    export const BASE_API = axios.create({
        baseURL: API_URL,
        headers: getBaseHeaders()
    })

    let uploadToast = null

    CRUD_API.interceptors.request.use((res) => {
        const token = getToken()
        if (token) {
            res.headers.Authorization = `bearer ${token}`
        }
        let hasFile = false
        if (res?.data) {
            const checkFiles = (data) => {
                Object?.values(data)?.map((item) => {
                    if (item instanceof File || item instanceof Blob) {
                        hasFile = true
                    } else if (item instanceof Array) {
                        item?.forEach((i) => {
                            checkFiles(i)
                        })
                    }
                })
            }
            checkFiles(res?.data)
        }
        if (hasFile) {
            uploadToast = toast.loading(i18next.t('Upload in progress...'))
            res.onUploadProgress = (progressEvent) => {
                const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                if (progress < 100) {
                    toast(`${i18next.t('Upload Progress')} : ${progress}%`, { id: uploadToast })
                } else {
                    toast(() => (
                        <span className='d-flex align-items-center'>
                            {i18next.t('The data is now being saved')}
                            <Spinner color="primary" size={8} className='mx-1'/>
                        </span>
                        ), {id : uploadToast})
                }
            }
        }
        if (res.data) {
            res.data = encryptData(res.data)
        }
        return res
    }, (err) => {
        return Promise.reject(err)
    })
    
    BASE_API.interceptors.request.use((res) => {
        const token = getToken()
        if (token) {
            res.headers.Authorization = `bearer ${token}`
        }
        if (res.data) {
            res.data = encryptData(res.data)
        }
        return res
    }, (err) => {
        return Promise.reject(err)
    })

    CRUD_API.interceptors.response.use((response) => {
        toast.remove(uploadToast)
        if (response.data) {
            try {
                response.data = decryptData(response.data)
            } catch (e) {
            }
        }
        return response
    }, (error) => {
        handleError(error?.response?.status)
        return Promise.reject(decryptData(error?.response?.data))
    })

    BASE_API.interceptors.response.use((response) => {
        if (response.data) {
            try {
                response.data = decryptData(response.data)
            } catch (e) {
            }
        }
        return response
    }, (error) => {
        handleError(error?.response?.status)
        return Promise.reject(decryptData(error?.response?.data))
    })